module.exports = __webpack_public_path__ + "01ea978f/img/document.e2130c6b.svg";